"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortHostnameConfigs = exports.hostnameConfigOrderBy = exports.HostnameConfig = exports.isHostnameConfig = exports.isHostnameType = void 0;
const validation_1 = require("../validator/validation");
const ValidatorClass_1 = require("../validator/ValidatorClass");
exports.isHostnameType = (0, validation_1.isLiteral)('PRIMARY', 'ALIAS');
exports.isHostnameConfig = (0, validation_1.isObjectOf)({
    hostname: validation_1.isString,
    type: exports.isHostnameType,
});
class HostnameConfig extends (0, ValidatorClass_1.ValidatorClass)(exports.isHostnameConfig) {
}
exports.HostnameConfig = HostnameConfig;
const hostnameConfigOrderBy = (first, second) => {
    const isPrimary = (hc) => 'PRIMARY' === hc.type;
    const compareByName = (one, two) => one.hostname.toLowerCase().localeCompare(two.hostname.toLowerCase());
    if (isPrimary(first) && isPrimary(second)) {
        return compareByName(first, second);
    }
    else if (isPrimary(first)) {
        return -1;
    }
    else if (isPrimary(second)) {
        return 1;
    }
    else {
        return compareByName(first, second);
    }
};
exports.hostnameConfigOrderBy = hostnameConfigOrderBy;
const sortHostnameConfigs = (list = []) => {
    return list.sort(exports.hostnameConfigOrderBy);
};
exports.sortHostnameConfigs = sortHostnameConfigs;
//# sourceMappingURL=HostnameConfig.js.map